<script>
import CreateBlog from './CreateBlog'
import { mapActions, mapGetters } from 'vuex'
import { pickBy, isEqual } from 'lodash'

export default {
  name: 'edit-blog',
  extends: CreateBlog,
  data () {
    return {
      modalName: 'edit-blog',
      blog: null,
      title: this.$t('blogEditTitle'),
      buttonTxt: this.$t('buttonSave')
    }
  },
  computed: {
    ...mapGetters({
      postCategories: 'entities/postCategories/list',
      blogCategories: 'entities/blogCategories/list'
    }),
    changedBlog () {
      if (!this.blog) return
      return pickBy({
        isAdult: this.isAdult,
        isPrivate: this.isPrivate,
        isHideOwner: this.isHideOwner,
        categoryId: this.categoryId,
        defaultLanguage: this.defaultLanguage && this.defaultLanguage.value
      }, (val, key) => val !== this.blog[key])
    },
    changedBlogInfo () {
      return Object.keys(this.blogInfo).map(lang => {
        const newBlogInfoObj = {
          ...this.blogInfo[lang],
          language: lang
        }
        const existedBlogInfoObj = this.blog.blogInfo.find(obj => obj.language === newBlogInfoObj.language)
        if (!existedBlogInfoObj) {
          if (!existedBlogInfoObj && newBlogInfoObj.name && newBlogInfoObj.description) {
            return newBlogInfoObj
          }
        } else {
          if (!isEqual(newBlogInfoObj, existedBlogInfoObj)) {
            return newBlogInfoObj
          }
        }
      }).filter(obj => obj != null)
    },
    isFormChanged () {
      if (!this.blog) return
      return !!Object.keys(this.changedBlog).length || !!this.changedBlogInfo.length
    },
    isButtonDisabled () {
      return !this.isFormChanged
    }
  },
  methods: {
    beforeOpen ({ params: { blog } }) {
      this.$v.$reset()
      this.loading = false
      this.blog = blog
      this.category = blog.category
      this.isAdult = blog.isAdult
      this.isPrivate = blog.isPrivate
      this.isHideOwner = blog.isHideOwner
      this.currentLanguage = blog.defaultLanguage
      this.defaultLanguage = this.locales.find(obj => obj.value === blog.defaultLanguage)
      blog.blogInfo.forEach(obj => {
        this.blogInfo[obj.language].name = obj.name
        this.blogInfo[obj.language].description = obj.description
        this.blogInfo[obj.language].id = obj.id
      })
      if (!this.blogCategories.length) this.getBlogCategories()
      if (!this.postCategories.length) this.getPostCategories()
    },
    ...mapActions({
      getBlogCategories: 'entities/blogCategories/fetch',
      getPostCategories: 'entities/postCategories/fetch'
    }),
    ...mapActions('entities/blogs', [
      'editBlog'
    ]),
    async onSubmit () {
      this.$v.$touch()
      if (!this.isFormChanged || this.loading || this.$v.$invalid) return
      this.loading = true
      try {
        await this.editBlog({
          uuid: this.blog.uuid,
          blog: this.changedBlog,
          blogInfo: this.changedBlogInfo
        })
        this.$modal.hide(this.modalName)
      } catch (e) {
        const error = e.response.data
        this.$modal.show('error', { error })
      } finally {
        this.loading = false
      }
    },
    deleteBlog () {
      this.$modal.show('delete-blog', {
        blogId: this.blog.shortId
      })
    }
  }
}
</script>
